const consoleMessage = () =>
  console.log(
    "         ____     ____\n        |    |   |    |\n     ___|    |___|    |___\n    |                     |\n    |                     | Want to work for HASH? We’re looking for developers like you.\n    |___      ___      ___|\n        |    |   |    |\n     ___|    |___|    |___\n    |                     |\n    |                     |	Find out more at: www.hash.ai/careers/developers?s=console\n    |___      ___      ___|\n        |    |   |    |\n        |____|   |____|"
  );

export default consoleMessage;
